/**
 * PureSpec add-to-cart handler
 * Integrates with the theme's cart event system so the cart drawer
 * opens and the cart icon badge updates after adding items.
 */
(function () {
  function addToCart(variantId, quantity, triggerEl) {
    if (!variantId || isNaN(parseInt(variantId, 10))) return;
    quantity = Math.max(1, parseInt(quantity, 10) || 1);

    if (triggerEl) {
      triggerEl.disabled = true;
      triggerEl.classList.add('ps-loading');
    }

    var sectionsToFetch = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      sectionsToFetch.push(el.dataset.sectionId);
    });

    var body = {
      id: parseInt(variantId, 10),
      quantity: quantity,
    };

    if (sectionsToFetch.length > 0) {
      body.sections = sectionsToFetch.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          console.error('Add to cart error:', data.description);
          return;
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'purespec-cart',
              data: {
                source: 'product-form-component',
                itemCount: quantity,
                variantId: String(variantId),
                sections: data.sections || {},
              },
            },
          })
        );
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
      })
      .finally(function () {
        if (triggerEl) {
          triggerEl.disabled = false;
          triggerEl.classList.remove('ps-loading');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ps-add-to-cart[data-variant-id]');
    if (btn && !btn.disabled) {
      e.preventDefault();
      var card = btn.closest('.ps-product-card');
      var qtyInput = card ? card.querySelector('.ps-qty-value') : null;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      addToCart(btn.dataset.variantId, quantity, btn);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#ps-product-form');
    if (!form) return;

    e.preventDefault();

    var variantInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!variantInput || !variantInput.value) return;

    var variantId = variantInput.value;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var submitBtn = form.querySelector('button[type="submit"]');

    addToCart(variantId, quantity, submitBtn);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart__checkout-button');
    if (btn && !btn.disabled) {
      btn.classList.add('ps-loading');
    }
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.cart__checkout-button.ps-loading').forEach(function (btn) {
      btn.classList.remove('ps-loading');
    });
  });
})();
